import React from 'react'
import {Button, Header, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import {useSelector} from "react-redux";
import {createUserLog} from "../../lib/api";

const ClearOverride =({tagid,tags,settags,option,channel,title,settempovrdata,settempoverriden,parentCallback}) => {

    const [toggle, setToggle] = React.useState();
    const [open,setOpen]= React.useState(false);
    const ppid = useSelector(state => state.header.ppid);
    const user = useSelector(state => state.nav.user);
    const electronApp = useSelector(state => state.nav.electronApp);

    const handleOpen = () => setOpen( true);
    const handleClose = () => setOpen( false);

    const handleToggle =(event, {id}) => {
        setToggle(id);
        event.preventDefault();
        if(id === '1') {
            if(option !== 3){
                if(option === 1 || option === 4) {
                    var adiodata = {'buttonClickType': channel, 'tags': tagid};
                    socket.emit('button click', adiodata);
                    setOpen(false);
                }
                else if (option === 2) {
                    var seqdata =   {'buttonClickType': channel};
                    socket.emit('button click', seqdata);
                    setOpen(false);
                }
                // update SOFC, channel === 'Clear Sequence All Overrides' -> channel.includes('Sequence Overrides') for PSM1~5
                if(channel.includes('Sequence Overrides')){
                    parentCallback(true);
                }else{
                    settags([...tags]);
                    settempoverriden({});
                    settempovrdata({});
                    parentCallback(true);
                }
            }
            else {
                var adiodata = {'buttonClickType': channel, 'tags': tagid};
                socket.emit('button click', adiodata);
                setOpen(false);
                // parentCallback(true);
                settags([...tags]);
                settempovrdata({});
                settempoverriden({});
                parentCallback(true);
            }
            // let display_id = (channel === 'Clear All Digital Overrides') ? 13 : (channel === 'Clear All Sequence Overrides') ? 44 : 2;
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ type: channel }),
                };
                createUserLog({ log }).catch(console.error);
            }
        }
        else if(id === '2'){
            setOpen(false);
        }
    }

    return (
        <div>
            {option === 2 || option === 3 ? // Sequence Override : option 2
                <Modal 
                    trigger = {<Button color ='blue'>{title} </Button>}
                    style = {styles.toggle}
                    open = {open}
                    onClose={handleClose}
                    onOpen={handleOpen}>
                    
                    <Modal.Header>Confirmation</Modal.Header>
                    <Modal.Description>
                        <Header style = {styles.header}> Do you want to {channel}?</Header>
                    </Modal.Description>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id = '1'
                                active={toggle==='1'}
                                content='OK'
                                onClick={handleToggle}
                        />
                        <Button color={'red'}
                                size='small'
                                id = '2'
                                active={toggle==='2'}
                                content='Cancel'
                                onClick={handleToggle}
                        />
                    </Modal.Actions>
                </Modal>
                :
                option === 4 ? // CLEAR OVERRIDES
                    <Modal 
                        trigger = {<Button color = 'blue'> CLEAR OVERRIDES </Button>}
                        style = {styles.toggle}
                        open = {open}
                        onClose={handleClose}
                        onOpen={handleOpen}>
                        <Modal.Header>Confirmation</Modal.Header>
                        <Modal.Description>
                            <Header style = {styles.header}> Do you want to {channel}?</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id = '1'
                                    active={toggle==='1'}
                                    content='OK'
                                    onClick={handleToggle}
                            />
                            <Button color={'red'}
                                    size='small'
                                    id = '2'
                                    active={toggle==='2'}
                                    content='Cancel'
                                    onClick={handleToggle}
                            />
                        </Modal.Actions>
                    </Modal>
                :
                <Modal 
                    trigger = {<Button color = 'blue'> CLEAR ALL OVERRIDES </Button>}
                    style = {styles.toggle}
                    open = {open}
                    onClose={handleClose}
                    onOpen={handleOpen}>
                    <Modal.Header>Confirmation</Modal.Header>
                    <Modal.Description>
                        <Header style = {styles.header}> Do you want to {channel}?</Header>
                    </Modal.Description>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id = '1'
                                active={toggle==='1'}
                                content='OK'
                                onClick={handleToggle}
                        />
                        <Button color={'red'}
                                size='small'
                                id = '2'
                                active={toggle==='2'}
                                content='Cancel'
                                onClick={handleToggle}
                        />
                    </Modal.Actions>
                </Modal>
            }
        </div>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    toggle: {
        maxWidth: '400px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '15px'
    }
}

export default ClearOverride;